// Cashless FWA score/rules for the digitisation request currently open in the
// dashboard. Separate from the `digitisation` reducer (which gets wholesale-
// replaced by SET_DIGITISATION) so a slow FWA fetch never clobbers/gets
// clobbered by the digitisation-request state.
export const defaultState = {
    digitisationRequestId: null,
    claim: null,
};

export default function fwaDigi(state = defaultState, action) {
    switch (action.type) {
        case 'SET_FWA_DIGI_CLAIM': {
            return {
                digitisationRequestId: action.payload.digitisationRequestId,
                claim: action.payload.claim,
            };
        }
        case 'CLEAR_FWA_DIGI_CLAIM': {
            return defaultState;
        }
        default:
            return state;
    }
}
